import { render, staticRenderFns } from "./organize.vue?vue&type=template&id=812c454c&scoped=true"
import script from "./organize.vue?vue&type=script&lang=js"
export * from "./organize.vue?vue&type=script&lang=js"
import style0 from "./organize.vue?vue&type=style&index=0&id=812c454c&prod&lang=less&scoped=true"
import style1 from "./organize.vue?vue&type=style&index=1&id=812c454c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812c454c",
  null
  
)

export default component.exports